"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.obfuscate = void 0;
var util_1 = require("util");
var url_parse_1 = __importDefault(require("url-parse"));
var lodash_1 = require("lodash");
// function match(m:Matcher<any>, ...args:[any, any]):boolean {
//   if (typeof m === 'function') {
//     return m(...args)
//   }
//   if (m instanceof RegExp) {
//     return m.test(String(args[0]))
//   }
//   if (typeof args[0] === 'string') {
//     return (m as string).includes(args[0])
//   }
//   return false
// }
// export function obfuscate(args:ObfuscateArgs) {
//   if (typeof args.object !== 'object') {
//     return args.object
//   }
//   let isCircular = false
//   try {
//     JSON.stringify(args)
//   } catch (e) {
//     isCircular = true
//   }
//   if (isCircular) {
//     try {
//       delete args.keys
//       delete args.values
//     } catch (e) {
//       // do nothing
//     }
//     return { ...args, WARNING: 'Circular reference detected' }
//   } else {
//     let newObj = { ...args.object }
//     const isKeySensitive = (data) => args.keys.some(k => match(k, data.key, 'key'))
//     const isValueSensitive = (data) => args.values.some(k => match(k, data.value, 'value'))
//     traverse(args.object, (data) => {
//       if (isKeySensitive(data) || isValueSensitive(data)) {
//         newObj = deepMerge(newObj, deepSet([data.path.join('.'), '[Obfuscated]']))
//       }
//     })
//     return newObj
//   }
// }
function removeKey(obj, key) {
    if (obj === null || obj === void 0 ? void 0 : obj.hasOwnProperty(key)) {
        obj[key] = '[secret]';
    }
    for (var subObj in obj) {
        if (typeof obj[subObj] == 'object') {
            removeKey(obj[subObj], key);
        }
    }
}
function removeValue(obj, value) {
    for (var subObj in obj) {
        var isString = typeof obj[subObj] == 'string';
        if (isString) {
            var isRegex = value instanceof RegExp;
            var match = isRegex ? value.test(obj[subObj]) : obj[subObj].includes(value);
            if (match) {
                if (obj[subObj].startsWith('http')) {
                    var url = (0, url_parse_1.default)(obj[subObj]);
                    obj[subObj] = "".concat(url.origin).concat(url.pathname, "/[secret]");
                }
                else {
                    obj[subObj] = '[secret]';
                }
            }
        }
        if (typeof obj[subObj] == 'object') {
            removeValue(obj[subObj], value);
        }
    }
}
function obfuscate(args) {
    var object = args.object, keys = args.keys, values = args.values;
    var isCircular = false;
    try {
        JSON.stringify(args);
    }
    catch (e) {
        isCircular = true;
    }
    if (typeof object === 'object' && !isCircular) {
        var cleanData_1 = {};
        try {
            cleanData_1 = (0, lodash_1.cloneDeep)(object);
            keys.forEach(function (fieldName) { return removeKey(cleanData_1, fieldName); });
            values.forEach(function (fieldName) { return removeValue(cleanData_1, fieldName); });
        }
        catch (err1) {
            try {
                cleanData_1 = (0, util_1.inspect)(object, { depth: 1 });
            }
            catch (err2) {
                cleanData_1 = { value: "Couldn't process data" };
            }
        }
        var result = cleanData_1;
        return result;
    }
    else {
        if (isCircular) {
            return __assign(__assign({}, args.object), { WARNING: 'Circular reference detected' });
        }
        else {
            return args.object;
        }
    }
}
exports.obfuscate = obfuscate;
